import axios from 'axios';
import authHeader from './auth-header';
import authFileHeader from './auth-file-header';
import Config from '../config/index';

class SystemSetupService {
    getSystemSetup() {
        return axios.get(Config.apiBasePath + '/system-setup/get',{ headers: authHeader() });
    }
    addSystemSetup(systemSetup) {
        return axios.post(Config.apiBasePath + '/system-setup/add', systemSetup,{ headers: authHeader() });
    }
    updateSystemSetup(systemSetup) {
        return axios.post( Config.apiBasePath + '/system-setup/update', systemSetup, { headers: authFileHeader() });
    }
}

export default new SystemSetupService();